/**
 * Shared page chrome — Patient module is the design source of truth.
 * UI-only tokens; do not couple to APIs or business logic.
 */

export const PAGE_SHELL = "w-full space-y-3 pb-6";
export const PAGE_STACK = "w-full space-y-4 pb-6";

export const PAGE_TITLE = "text-2xl font-bold text-slate-800";
export const PAGE_SUBTITLE = "text-sm text-slate-500 mt-0.5";
export const PAGE_HEADER_ROW =
  "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3";
export const PAGE_ACTIONS = "flex flex-wrap items-center gap-2 shrink-0";

/**
 * Module tab strip (Dashboard, Patient, Documents, Reports, Billing, …).
 * Slightly larger, bold labels so names stay readable in the grid.
 */
export const MODULE_TAB_BTN =
  "relative flex items-center justify-center gap-2 w-full px-2.5 py-3 text-[15px] font-bold leading-snug whitespace-nowrap border-r last:border-r-0 transition-colors";
export const MODULE_TAB_BTN_SCROLL =
  "relative flex items-center justify-center gap-2 px-4 py-3 text-[15px] font-bold leading-snug whitespace-nowrap border-r last:border-r-0 transition-colors capitalize shrink-0";
export const MODULE_TAB_ICON_SIZE = 17;

export const PANEL =
  "bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden";
export const PANEL_TOOLBAR =
  "flex flex-col sm:flex-row sm:items-center gap-2.5 px-3 py-2.5 border-b border-slate-100";

export const SEARCH_INPUT =
  "w-full h-8 pl-9 pr-8 text-sm bg-white border border-slate-200 rounded-md text-slate-800 placeholder:text-slate-400 outline-none transition-colors focus:border-blue-400 focus:ring-2 focus:ring-blue-100";

export const FILTER_SELECT =
  "appearance-none h-8 min-w-[140px] pl-3 pr-8 text-sm rounded-md border border-slate-200 text-slate-700 bg-white outline-none cursor-pointer focus:border-blue-400 focus:ring-2 focus:ring-blue-100";

export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium text-blue-700 bg-white border border-blue-300 rounded-md hover:bg-blue-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

export const BTN_SECONDARY =
  "inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-md hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

export const BTN_DANGER =
  "inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium text-red-700 bg-white border border-red-200 rounded-md hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

export const BTN_ROW =
  "inline-flex items-center gap-1 h-6 px-2 text-[11px] font-medium text-blue-700 bg-white border border-blue-200 rounded hover:bg-blue-50 hover:border-blue-300 transition-colors disabled:opacity-50";

export const MODAL_BACKDROP =
  "fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40";
export const MODAL_PANEL =
  "w-full max-w-md rounded-xl border border-slate-200 bg-white shadow-xl";
export const MODAL_HEADER =
  "flex items-center justify-between gap-3 px-4 py-3 border-b border-slate-100";
export const MODAL_TITLE = "text-sm font-semibold text-slate-900";
export const MODAL_BODY = "p-4 space-y-3";
export const MODAL_FOOTER = "flex justify-end gap-2 pt-2";

export const CELL = "text-[13px] text-slate-700 leading-none";
export const CELL_MUTED = "text-[13px] text-slate-600 leading-none";
export const CELL_STRONG = "text-[13px] font-medium text-slate-900 leading-none";

export const SPINNER =
  "w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin";
